import { render, staticRenderFns } from "./FeatureRequestTable.vue?vue&type=template&id=5eb29dd6&scoped=true"
import script from "./FeatureRequestTable.vue?vue&type=script&lang=js"
export * from "./FeatureRequestTable.vue?vue&type=script&lang=js"
import style0 from "./FeatureRequestTable.vue?vue&type=style&index=0&id=5eb29dd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb29dd6",
  null
  
)

export default component.exports